var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 18.7,
  width: 1.8,
  height: 5.5,
  fill: "#6e5334"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 35.2,
  y: 18.7,
  width: 1.8,
  height: 5.5,
  fill: "#6e5334"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 5.5,
  y: 16.5,
  width: 34,
  height: 2.2,
  rx: 1,
  fill: "#8a6238"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.5,
  cy: 15,
  rx: 5,
  ry: 2.5,
  fill: "#e8b45a"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.5,
  cy: 15,
  rx: 3.9,
  ry: 1.85,
  fill: "#f2c14e"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.9,
  cy: 14.7,
  r: 0.6,
  fill: "#c8503f"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.4,
  cy: 15.6,
  r: 0.6,
  fill: "#c8503f"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 14.3,
  r: 0.6,
  fill: "#c8503f"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.3,
  cy: 13.3,
  r: 1.25,
  fill: "#57b368"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 12.6,
  r: 1.45,
  fill: "#57b368"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.7,
  cy: 13.3,
  r: 1.25,
  fill: "#57b368"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 13.6,
  r: 0.55,
  fill: "#c8503f"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m18.8 13.8h6.4c0 1.9-1.4 2.9-3.2 2.9s-3.2-1-3.2-2.9z",
  fill: "#dfe6ec"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m25.9 16.5 3-5 3 5z",
  fill: "#d9c9a8"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m27.2 16.5 3-5 3 5z",
  fill: "#e8ddc8"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m28.2 15.2h4.1l0.5 0.8h-5.1z",
  fill: "#c8503f"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 34.4,
  y: 11.8,
  width: 2.2,
  height: 4.7,
  rx: 1,
  fill: "#9fd8ef"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 34.95,
  y: 10.9,
  width: 1.1,
  height: 1.1,
  rx: 0.3,
  fill: "#4a7fa5"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 34.4,
  y: 13.7,
  width: 2.2,
  height: 1.2,
  fill: "#eef1f5"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 37.2,
  y: 11.8,
  width: 2.2,
  height: 4.7,
  rx: 1,
  fill: "#9fd8ef"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 37.75,
  y: 10.9,
  width: 1.1,
  height: 1.1,
  rx: 0.3,
  fill: "#4a7fa5"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 37.2,
  y: 13.7,
  width: 2.2,
  height: 1.2,
  fill: "#eef1f5"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 26.3,
  width: 6,
  height: 6.5,
  rx: 2,
  fill: "#3c4652"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 10.4,
  y: 32.5,
  width: 7.2,
  height: 1.9,
  rx: 0.9,
  fill: "#3c4652"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 13.35,
  y: 34.4,
  width: 1.3,
  height: 2.2,
  fill: "#5c6870"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 11.3,
  y: 36.6,
  width: 5.9,
  height: 1.1,
  rx: 0.55,
  fill: "#5c6870"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 27.5,
  y: 26.3,
  width: 6,
  height: 6.5,
  rx: 2,
  fill: "#3c4652"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 26.9,
  y: 32.5,
  width: 7.2,
  height: 1.9,
  rx: 0.9,
  fill: "#3c4652"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 29.85,
  y: 34.4,
  width: 1.3,
  height: 2.2,
  fill: "#5c6870"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  x: 27.8,
  y: 36.6,
  width: 5.9,
  height: 1.1,
  rx: 0.55,
  fill: "#5c6870"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 30,
  width: 39,
  height: 3.4,
  rx: 1.6,
  fill: "#5f7d95"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 33.4,
  width: 3,
  height: 6.6,
  fill: "#46626d"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 33.4,
  width: 3,
  height: 6.6,
  fill: "#46626d"
});

function SvgInMeetingFoodRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInMeetingFoodRequest);
export default __webpack_public_path__ + "static/media/in-meeting-food-request.4daacc32644c050cf2ded3fe5cf51f87.svg";
export { ForwardRef as ReactComponent };